const usersHeaders = [
  {
    key: 'id',
    text: 'ID',
    type: 'CHECKBOX',
    sortable: false,
    dataType: 'number'
  },
  {
    key: 'accessId',
    text: 'Login ID',
    type: 'DEFAULT',
    sortable: false,
    dataType: 'text',
    props: { th: { className: 'large-col' }, td: { className: 'big-text' } }
  },
  {
    key: 'email',
    text: 'Email',
    type: 'DEFAULT',
    sortable: false,
    dataType: 'text',
    props: { th: { className: 'medium-col' } }
  },
  {
    key: 'role',
    text: 'Função',
    type: 'DEFAULT',
    sortable: false,
    dataType: null,
    props: { th: { className: 'small-col' } }
  },
  {
    key: 'createdAt',
    text: 'Dt. Criação',
    type: 'DEFAULT',
    dataType: 'date',
    props: { th: { className: 'small-col' } }
  },
  {
    key: 'updatedAt',
    text: 'Dt. Atuali.',
    type: 'DEFAULT',
    dataType: 'date',
    props: { th: { className: 'small-col' } }
  }
];

export default usersHeaders;
